import * as React from 'react';
import Header from '@component/Header'
import Bottom from '@component/Bottom'
// import { Link } from 'react-router-dom';
import ReturnTop from '@component/ReturnTop'
import { BottomCooperativeMedia, AdList } from '@src/constants'
import './style.scss'
let intervalTime: any;
let intervalTime2: any;

export interface IAboutUsStates {
  left: number,
  left2: number,
  mediaList: any

}

export default class AboutUs extends React.Component<any, IAboutUsStates> {
  constructor(props: any) {
    super(props)
    this.state = {
      left: 0,
      left2: 0,
      mediaList: [...BottomCooperativeMedia, ...BottomCooperativeMedia]
    }
  }

  public componentDidMount() {
    document.title = "域起火爆棋牌游戏-经典捕鱼游戏-域起精品手游"
    document.getElementsByTagName("meta")[4].content = '域起官网,域起精品手游,热门棋牌游戏平台,火爆捕鱼游戏'
    document.getElementsByTagName("meta")[5].content = '上海域起网络科技有限公司是中国领先的游戏开发商。公司主要业务集中在互联网手机游戏，互联网应用等领域 。公司旗下产品有《哥哥游戏平台》,《哥哥捕鱼》,《梦幻炫舞》,《青空之刃》等诸多精品手游。'
    scrollTo(0, 0)
    this.startInterval()
  }

  public stopInterval() {
    clearInterval(intervalTime)
    clearInterval(intervalTime2)
  }

  public componentWillUnmount() {
    clearInterval(intervalTime)
    clearInterval(intervalTime2)
  }

  public startInterval() {
    intervalTime = setInterval((() => {
      if (Math.ceil(this.state.left) === - 110) {
        this.setState({ left: 0 });
      }
      this.setState({ left: this.state.left - 0.125 });
    }), 30)

    intervalTime2 = setInterval((() => {
      if (Math.ceil(this.state.left2) === - 59) {
        this.setState({ left2: 0 });
      }
      this.setState({ left2: this.state.left2 - 0.125 });
    }), 30)
  }

  public render() {
    return (
      <div className="pc-about-us">
        <Header />
        <img className="header-img" src={require('@static/2019091622.jpg')} alt="域起官网" />
        <div className="main-content">
          {/* <div className="nav-about-us"><Link to={{ pathname: `/` }}>首页</Link> > 关于我们</div> */}
          <div className="title-style">快乐游戏，快乐生活！</div>
          <div className="company-describe">
          上海域起网络科技有限公司成立于 2009 年，一直秉承“通过科技和艺术改变世界”的文化使命，专注于新一代智能手机软件开发与移动互联网运营，是一家集游戏研发和发行于一体的高新技术企业。
          公司拥有5A级办公环境，积极推崇硅谷文化，凭借过硬的研发实力，自主研发并发行了《梦幻炫舞》、《青空之刃》、《GG游戏大厅》、《project NOVA》等多款游戏，在全球拥有上亿注册用户。未来还将开拓更多领域，进一步完
          善公司的产业线布局，立足全球化视野，开拓产业发展战略新步伐。
        </div>
          <div className="two-describe-pic">
            <img src={require('@static/2019091633.png')} alt="域起官网" />
            <img src={require('@static/20190916444.png')} alt="域起官网" />
          </div>
          <div className="title-style">商务合作</div>
          <div className="call-me">
            <div>市场联系：shichang@gg.com</div>
            <div>媒介联系：1625043997（QQ）</div>
            <div>客服联系：4006800885</div>
            <div>商务联系：<img className="qrcode-lhm" src={require("@static/20190916erwm.png")} alt="域起官网" /> </div>
          </div>
          <div className="title-style">
            <div>合作渠道</div>
            <div id="mediaAvatar" className="media-avatar" >
              <p className="first-p" style={{ 'marginLeft': this.state.left + 'rem' }} />
              {AdList.map((item: any, index: any) => {
                return <img key={index} className="img-style" src={item.src} alt="域起官网" />
              })}
            </div>
          </div>

          <div className="title-style">
            <div>合作媒体</div>
            <div id="mediaAvatar" className="media-avatar">
              <p className="first-p" style={{ 'marginLeft': this.state.left2 + 'rem' }} />
              {this.state.mediaList.map((item: any, index: any) => {
                return <img key={index} className="img-style" src={item.src} alt="域起官网" />
              })}
            </div>
          </div>
        </div>
        {/* <img className="work-with-us" src={require('@static/2019091610.png')} alt="域起官网" /> */}
        <ReturnTop />
        <Bottom />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutUs/index.tsx